import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  Avatar,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemButton,
  Divider,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";

const LoginAccountSelectionDialog = ({
  open,
  onClose,
  accountsList,
  handleAccountSelect,
  primaryColor,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    sx={{
      "& .MuiPaper-root": {
        borderRadius: "20px",
        padding: 2,
      },
    }}
  >
    <DialogContent>
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Avatar
          sx={{
            bgcolor: "rgba(51, 51, 51, 0.1)",
            color: primaryColor,
            width: 56,
            height: 56,
            margin: "0 auto",
            mb: 2,
          }}
        >
          <PersonIcon fontSize="large" />
        </Avatar>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          Select Account
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Multiple accounts found for this email. Please select the account you want to recover.
        </Typography>
      </Box>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {accountsList.map((account) => (
          <React.Fragment key={account.user_id}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={() => handleAccountSelect(account.user_id)}
                sx={{
                  borderRadius: "12px",
                  mb: 1,
                  "&:hover": {
                    backgroundColor: "rgba(51, 51, 51, 0.05)",
                  },
                }}
              >
                <ListItemAvatar>
                  <Avatar sx={{ bgcolor: primaryColor }}>
                    {account.username.charAt(0).toUpperCase()}
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={account.full_name || account.username}
                  secondary={
                    account.role || "User"
                  }
                />
              </ListItemButton>
            </ListItem>
            <Divider component="li" />
          </React.Fragment>
        ))}
      </List>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
      <Button
        onClick={onClose}
        sx={{
          color: "text.secondary",
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);

export default LoginAccountSelectionDialog;
